import {
    collection,
    addDoc,
    updateDoc,
    doc,
    query,
    where,
    getDocs,
    getDoc,
    serverTimestamp,
    deleteDoc
} from 'firebase/firestore';
import { db } from '../../firebase/firebaseConfig'; // Fixed path depth if needed, checking existing file it was ../../ so correct
import { COLLECTIONS } from '../../constants/collections';

const COLLECTION_NAME = COLLECTIONS.VEHICLE_TYPES;

const getCollectionPath = (tenantId) => `tenants/${tenantId}/${COLLECTION_NAME}`;


/**
 * Get all vehicle types for a tenant
 * @param {string} tenantId 
 * @returns {Promise<Array>} List of vehicle types
 */
export const getVehicleTypes = async (tenantId) => {
    try {
        if (!tenantId) throw new Error('Tenant ID is required');

        const q = query(
            collection(db, getCollectionPath(tenantId))
        );

        const querySnapshot = await getDocs(q);
        return querySnapshot.docs
            .map(doc => ({ id: doc.id, ...doc.data() }))
            .filter(item => item.isDeleted !== true);
    } catch (error) {
        console.error('Error fetching vehicle types:', error);
        throw error;
    }
};

/**
 * Create a new vehicle type
 * @param {Object} data - { tenantId, name, code, maxWeight, maxVolume, icon }
 * @param {string} tenantId
 */
export const createVehicleType = async (data, tenantId) => {
    try {
        if (!tenantId) throw new Error('Tenant ID is required');

        const payload = {
            ...data,
            tenantId,
            createdAt: serverTimestamp(),
            updatedAt: serverTimestamp(),
            isDeleted: false,
            isActive: true
        };

        const docRef = await addDoc(collection(db, getCollectionPath(tenantId)), payload);
        return { id: docRef.id, ...payload };
    } catch (error) {
        console.error('Error creating vehicle type:', error);
        throw error;
    }
};

/**
 * Update an existing vehicle type
 * @param {string} id 
 * @param {Object} data 
 * @param {string} tenantId 
 */
export const updateVehicleType = async (id, data, tenantId) => {
    try {
        if (!tenantId) throw new Error('Tenant ID is required');
        const docRef = doc(db, getCollectionPath(tenantId), id);
        const payload = {
            ...data,
            updatedAt: serverTimestamp()
        };
        await updateDoc(docRef, payload);
        return { id, ...payload };
    } catch (error) {
        console.error('Error updating vehicle type:', error);
        throw error;
    }
};

/**
 * Soft delete a vehicle type
 * @param {string} id 
 * @param {string} tenantId
 */
export const deleteVehicleType = async (id, tenantId) => {
    try {
        if (!tenantId) throw new Error('Tenant ID is required');
        const docRef = doc(db, getCollectionPath(tenantId), id);
        await updateDoc(docRef, {
            isDeleted: true,
            updatedAt: serverTimestamp()
        });
        return id;
    } catch (error) {
        console.error('Error deleting vehicle type:', error);
        throw error;
    }
};
